import { render } from "./CombinationForm.vue?vue&type=template&id=8df36ea8"
import script from "./CombinationForm.vue?vue&type=script&lang=js"
export * from "./CombinationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__